import React from "react";
import Footer from "./Footer";
import { UNAVAILABLE } from "./StatusOptions";
import DefinitionSVG from "./svg/DefinitionSVG";
import SVGServer from "./svg/SVGServer";
import strings from "./strings";


export default ({ datacenters }) => {
  return (
    <div className="container equal">
      <div className="row equal">
        <DefinitionSVG />
        {datacenters.map((dc) => {
          return (
            <div className="col-xs-12 col-sm-6 equal" key={dc.name}>
              <div
                className={`cloud-card col-xs-12 ${
                  dc.status === UNAVAILABLE ? "disabled" : ""
                }`}
                onClick={() => (window.location = dc.url)}
              >
                <div className="card-inside-left">
                  <SVGServer status={dc.status} />
                  <div>
                    <div className="name-and-logo">
                      <h3 style={{ fontWeight: "bold" }}>{dc.name}</h3>
                    </div>
                    <p>{dc.url}</p>
                    <h4 className={"status-text-" + dc.status.toUpperCase()}>
                      {dc.statusText}
                    </h4>
                  </div>
                </div>
                <div className="card-inside-right">
		  <figure>
                    <img
                      src={`${dc.url}/.usage`}
                      alt="Usage info"
                      style={{ width: "150px", height: "100%" }}
                    ></img>
		    <figcaption style={{textAlign: "center"}}>{strings.caption}</figcaption>
		  </figure>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <Footer />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Datacenters.js